<div class="ch-ggs-web-suite-boxed-gray">
  <span *ngIf="contact; else notFound">
    <address>
      {{ contact.Name }}<br />
      {{ contact.ZipAndCity }}<br />
      {{ contact.Country }}<br />
      <a [href]="'tel:' + contact.Phonenumber">{{ contact.Phonenumber }}</a
      ><br />
      <a [href]="'mailto:' + contact.Email">{{ contact.Email }}</a>
    </address>
  </span>
</div>

<ng-template #notFound>
  <ng-container
    *ngIf="accountContactTranslations$ | async as accountContactTranslations"
  >
    {{ accountContactTranslations['NoContactInformationAvailableYet'] }}
  </ng-container>
</ng-template>
